<template>
  <div>
    <div class="app-container">
      <div class="banner m-prof-banner position-relative">
        <div v-if="isBackgroundImageLoading" class="d-flex align-items-center flex-column justify-content-center mt-4">
          <div :style="{ height: '400px' }"><div class="spinner-border spinner-class"></div></div>
        </div>
        <!-- <img v-show="!isBackgroundImageLoading" :src="authUser.user.bg_img ? authUser.user.bg_img[0].url : `${'../../../../assets/images/defaultBackImg.jpg'}`" @load="onLoadHandler" alt="" /> -->
        <img v-else-if="authUser.user.bg_img" :src="authUser.user.bg_img && authUser.user.bg_img[0].url" @load="onLoadHandler" alt="bg-image" />
        <img v-else src="https://mycircle-prod.s3.amazonaws.com/default-profile-bg-img1698993539.jpg" alt="background" class="default-profile-bg-img" />
        <div class="camera-icon-button profile-bg h-100" :style="{ right: '132px' }">
          <button
            class="threedot-menu"
            @click="
              () => {
                $refs.drawerBackgroundRef.isMobile ? $refs.drawerBackgroundRef.show() : (displaypicDots = !displaypicDots)
              }
            "
            :style="{ top: '370px', position: 'relative', 'min-width': '300px' }"
          >
            <div class="dot-menu-cont">
              <div class="camera-icon-btn">
                <label class="camera-bttn cp d-flex justify-content-center align-items-center" aria-hidden="true" :style="{ background: getPrimaryColor() }">
                  <font-awesome-icon size="2x" :style="{ color: 'white !important', transform: 'scale(0.5)', height: '100%' }" :icon="['fas', 'camera']" />
                </label>
              </div>
            </div>

            <div :class="`${displaypicDots ? 'menu-content shadow-card active' : 'menu-content shadow-card'}`">
              <p class="card-item" @click="() => $refs.bgImageGalleryModal.show(backgroundImages)">
                <font-awesome-icon size="1x" :icon="['fal', 'images']" class="mr-2" />
                Select image
              </p>
              <p class="card-item position-relative">
                <font-awesome-icon size="1x" :icon="['fal', 'arrow-from-bottom']" class="mr-2" />
                <input
                  title=""
                  class="camera-icon-inp position-absolute h-100 w-100"
                  type="file"
                  accept="image/png, image/jpeg, image/gif, image/svg+xml"
                  ref="bg"
                  @change="handleBackgroundPicUpload()"
                  :style="{ left: '0', opacity: '0' }"
                />
                Upload image
              </p>
              <p class="divider"></p>
              <p :class="`card-item ${authUser.user.bg_img ? '' : 'disabled-remove-bg-btn'}`" @click="removebgImage()">
                <font-awesome-icon size="1x" :icon="['fal', 'trash']" class="mr-2" />
                Remove
              </p>
            </div>
          </button>
        </div>
      </div>
      <div class="profile-subnav">
        <div class="dovemed-wrapper w-100">
          <div class="d-flex justify-content-between">
            <div class="d-flex advocate-profile-card-container">
              <button class="threedot-menu mob" :style="{ background: '#fff', border: 'none', display: 'flex', 'align-self': 'flex-end' }" @click="() => (displayDots = !displayDots)">
                <font-awesome-icon size="1x" :style="{ color: '#94A3B8' }" :icon="['fas', 'ellipsis-v']" />
                <div
                  class="option-mob"
                  v-if="displayDots"
                  :style="{ display: 'flex', 'flex-direction': 'column', 'align-self': 'flex-end', gap: '12px', 'z-index': '2' }"
                  :class="`${displayDots ? 'menu-content shadow-card active' : 'menu-content shadow-card'}`"
                >
                  <p class="card-item d-flex flex-row" :style="{ 'font-weight': '500', color: 'black' }" @click="() => $refs.ShareProfileModal.showModal()">
                    <svg width="20" height="20" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
                      <path
                        d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
                        fill="black"
                      /></svg
                    >Share Profile
                  </p>
                </div>
              </button>
              <div class="profile-image mr-3 position-relative">
                <a-avatar v-if="isFetchingprofileimage" :style="{ color: ' #ffffff !important', 'background-color': authUser.user.url ? authUser.user.url : '' ? '' : '#EF8585' }" :size="150">
                  <div>
                    <div class="spinner-border spinner-class2"></div>
                  </div>
                </a-avatar>

                <a-avatar
                  v-if="!isFetchingprofileimage"
                  :style="{ color: ' #ffffff !important', 'background-color': authUser.user.url ? '' : '#EF8585' }"
                  :size="150"
                  :src="authUser.user.url"
                  class="text-capitalize"
                >
                  {{ authUser.user.display_name[0] }}
                </a-avatar>

                <!-- ---------------- profile pic ------------ -->
                <div :style="{ position: 'absolute', top: '-4px', left: '125px' }">
                  <button class="threedot-menu profile-avatar" @click="() => (displayprofileDots = !displayprofileDots)">
                    <div class="dot-menu-cont">
                      <div class="camera-icon-btn cp">
                        <label class="camera-bttn cp d-flex d-flex justify-content-center align-items-center" aria-hidden="true" :style="{ background: getPrimaryColor() }">
                          <font-awesome-icon size="2x" :style="{ color: 'white !important', transform: 'scale(0.5)', height: '100%' }" :icon="['fas', 'camera']" />
                        </label>
                      </div>
                    </div>
                    <div :class="`${displayprofileDots ? 'menu-content shadow-card active' : 'menu-content shadow-card'}`" :style="{ width: '150px' }">
                      <!-- <p class="card-item" @click="() => $refs.avatarModal.show()">
                        <font-awesome-icon size="1x" :icon="['fal', 'user-ninja']" class="mr-2" />
                        Create avatar
                      </p> -->
                      <p
                        class="card-item"
                        @click="
                          () => {
                            $refs.profileImageGalleryModal.show()
                          }
                        "
                      >
                        <font-awesome-icon size="1x" :icon="['fal', 'images']" class="mr-2" />
                        Select avatar
                      </p>
                      <p class="card-item position-relative">
                        <font-awesome-icon size="1x" :icon="['fal', 'arrow-from-bottom']" class="mr-2" />
                        <input
                          title=""
                          class="cp camera-icon-inp position-absolute w-100"
                          type="file"
                          accept="image/png, image/jpeg, image/gif, image/svg+xml"
                          ref="wfile"
                          @change="handleWebProfilePicUpload()"
                          :style="{ left: '0', opacity: '0' }"
                        />
                        Upload image
                      </p>
                      <p class="divider"></p>
                      <p class="card-item" @click="removeProfileImage()">
                        <font-awesome-icon size="1x" :icon="['fal', 'trash']" class="mr-2" />
                        Remove
                      </p>
                    </div>
                  </button>
                </div>
              </div>
              <div class="doc-info" :style="{ 'margin-top': '26.5px !important' }">
                <p class="m-0 doc-name text-capitalize" v-if="authUser">
                  {{ authUser.user.display_name }}
                </p>
                <div class="tags">
                  <div class="tag" :style="{ background: getPrimary50Color(), color: getPrimaryColor() }">
                    <font-awesome-icon class="icon" :icon="['fal', 'bullhorn']" :style="{ color: getPrimaryColor() }" /> Advocate
                  </div>
                  <div v-if="profileData.represent_organization" class="support-tag">Supporting {{ profileData.represent_organization }}</div>
                  <!-- <div class="tag" :style="{background: getPrimary50Color() , color: getPrimaryColor()  }">
                    Organise I support
                  </div> -->
                </div>
                <p :style="{ color: '#0F1734', 'margin-top': '17.5px !important' }" v-if="location && location[0].city" class="m-0 doc-loc d-flex align-items-center gap8">
                  <font-awesome-icon size="1x" :style="{ color: '#0F1734' }" :icon="['fal', 'map-marker-alt']" />
                  <span class="m-0 loc">
                    {{ location[0].city }},
                    {{ location[0].state }}
                  </span>
                </p>
                <div class="join-detail" v-if="joinedDate">Member since: {{ formatDate(joinedDate) }}</div>
              </div>
              <div class="d-flex justify-content-center mt-5">
                <div class="d-flex flex-row info-phy claim-card" :style="{ 'margin-top': '16px', padding: '24px 8px', width: '335px', height: '92px', border: 'none' }">
                  <div class="d-flex flex-column" :style="{ 'margin-right': '45px', 'text-align': 'center', 'padding-left': '30px', border: 'none' }">
                    <p class="prof-details-value">
                      {{ circleMembers ? circleMembers : 0 }}
                    </p>
                    <p class="prof-details-title">Circle Members</p>
                  </div>
                  <div class="divider" :style="{ background: '#CBD5E1', border: '1px solid #CBD5E1', height: '36px' }"></div>
                  <div class="d-flex flex-column" :style="{ 'padding-left': '70px', 'text-align': 'center' }">
                    <p class="prof-details-value">
                      {{ circlesOn ? circlesOn : 0 }}
                    </p>
                    <p class="prof-details-title">Circle On</p>
                  </div>
                </div>
              </div>

              <div class="mt-5 w-100 mb-4" :style="{ 'z-index': '10' }">
                <div class="d-flex align-items-center mb-2">
                  <h5 class="m-0 gray700 font20 fw700 flex1">Profile Completion</h5>
                  <button
                    class="d-flex align-items-center gap4 px-3 py-1 br8 fw700 font14"
                    :style="{ background: getPrimary50Color(), color: getPrimaryColor(), border: 'none' }"
                    @click="handleProfileEdit"
                  >
                    <font-awesome-icon :style="{ color: getPrimary300Color() }" :icon="['fas', 'pen']" class="font14" />
                    Edit
                  </button>
                </div>
                <a-progress :key="percentTotal" :percent="percentTotal" class="custom-progress" :strokeColor="getPrimaryColor()" :format="percent => `${percent}%`" />

                <p class="mt-4 mb-2 gray700 font16 fw700">Complete Profile</p>

                <SimpleLoader v-if="loadingProfC" :name="'profile completeness data'" class="mx-auto" />

                <div v-if="options.length && !loadingProfC">
                  <div v-for="(item, index) in options" :key="index">
                    <div :class="`${index % 2 === 0 ? 'bg-white' : 'bg-gray100'} d-flex align-items-center px-2 py-3`">
                      <font-awesome-icon class="success500 font20 ml-1" :icon="['fas', 'check-circle']" v-if="item.done" />
                      <p class="m-0 gray700 font16 ml-2">{{ `${item.display_name} - ${item.value}%` }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- right content -->
            <div class="nav-sec p-4">
              <!-- <div class='btns'>
                <button
                  class='dovemed-button font-white ml-4 primary-button'
                   :style="{background: getPrimaryColor()}"
                  @click="$router.push({name: 'MeetPeople'})"
                >VIEW OTHER PROFILE</button>
              </div> -->
              <div class="mt-1 profile-tabs">
                <div
                  id="updates"
                  :class="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/updates` ? 'active-tabs cp' : 'tabs cp'"
                  :style="
                    this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/updates` ? { color: getPrimaryColor(), background: getPrimary50Color() } : { color: '#0F1734' }
                  "
                  @click="handletab($event)"
                >
                  Updates
                </div>
                <div
                  id="about"
                  :class="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/about` ? 'active-tabs cp' : 'tabs cp'"
                  :style="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/about` ? { color: getPrimaryColor(), background: getPrimary50Color() } : { color: '#0F1734' }"
                  @click="handletab($event)"
                >
                  About
                </div>
                <div
                  :style="
                    this.$route.path.includes('allCircleMembers') ||
                    this.$route.path.includes('AllCircleMembers') ||
                    this.$route.path.includes('self') ||
                    this.$route.path.includes('hospitals') ||
                    this.$route.path.includes('clinics') ||
                    this.$route.path.includes('nfp') ||
                    this.$route.path.includes('hcp') ||
                    this.$route.path.includes('providers')
                      ? { color: getPrimaryColor(), background: getPrimary50Color() }
                      : { color: '#0F1734' }
                  "
                  id="circles"
                  :class="
                    this.$route.path.includes('allCircleMembers') ||
                    this.$route.path.includes('AllCircleMembers') ||
                    this.$route.path.includes('self') ||
                    this.$route.path.includes('hospitals') ||
                    this.$route.path.includes('clinics') ||
                    this.$route.path.includes('nfp') ||
                    this.$route.path.includes('hcp') ||
                    this.$route.path.includes('providers')
                      ? 'active-tabs'
                      : 'tabs'
                  "
                  @click="handletab($event)"
                >
                  Circles
                </div>
                <a-dropdown :trigger="['click']" v-model="displayDots2W" :getPopupContainer="trigger => trigger.parentNode">
                  <div
                    :style="
                      this.$route.path.includes('muteduser') ||
                      this.$route.path.includes('qa') ||
                      this.$route.path.includes('polls') ||
                      this.$route.path.includes('saved') ||
                      this.$route.path.includes('profilerev') ||
                      this.$route.path.includes('medrev') ||
                      this.$route.path.includes('profilercmnd') ||
                      this.$route.path.includes('treatmentrcmnd')
                        ? { color: getPrimaryColor(), background: getPrimary50Color() }
                        : { color: '#0F1734' }
                    "
                    id="reviews"
                    :class="
                      this.$route.path.includes('muteduser') ||
                      this.$route.path.includes('qa') ||
                      this.$route.path.includes('polls') ||
                      this.$route.path.includes('saved') ||
                      this.$route.path.includes('profilerev') ||
                      this.$route.path.includes('medrev') ||
                      this.$route.path.includes('profilercmnd') ||
                      this.$route.path.includes('treatmentrcmnd')
                        ? 'active-tabs'
                        : 'tabs'
                    "
                  >
                    <div
                      :style="
                        this.$route.path.includes('muteduser') ||
                        this.$route.path.includes('qa') ||
                        this.$route.path.includes('polls') ||
                        this.$route.path.includes('saved') ||
                        this.$route.path.includes('profilerev') ||
                        this.$route.path.includes('medrev') ||
                        this.$route.path.includes('profilercmnd') ||
                        this.$route.path.includes('treatmentrcmnd')
                          ? { color: getPrimaryColor() }
                          : ''
                      "
                      class="tabe"
                    >
                      <!-- {{ selectedTab }} -->
                      {{ "Reviews & More" }}
                      <font-awesome-icon size="1x" :icon="displayDots2W ? ['far', 'angle-up'] : ['far', 'angle-down']" class="mr-2" />
                    </div>
                  </div>
                  <template #overlay>
                    <a-menu>
                      <a-menu-item
                        id="qa"
                        @click="
                          () => {
                            selectedTab = 'Q&A'
                            $router.push({ name: 'AdvocateQA' })
                          }
                        "
                        class="card-item"
                      >
                        Q&A
                      </a-menu-item>
                      <a-menu-item
                        id="polls"
                        @click="
                          () => {
                            selectedTab = 'Polls'
                            $router.push({ name: 'AdvocatePolls' })
                          }
                        "
                        class="card-item"
                      >
                        Polls
                      </a-menu-item>
                      <a-menu-item
                        id="saved"
                        @click="
                          () => {
                            selectedTab = 'Saved'
                            $router.push({ name: 'AdvocateFav' })
                          }
                        "
                        class="card-item"
                      >
                        Saved
                      </a-menu-item>
                      <a-menu-item
                        id="profilerev"
                        @click="
                          () => {
                            selectedTab = 'Profile Reviews'
                            $router.push({ name: 'AdvocateProfileReview' })
                          }
                        "
                        class="card-item"
                      >
                        Profile Reviews
                      </a-menu-item>
                      <a-menu-item
                        id="medrev"
                        @click="
                          () => {
                            selectedTab = 'Medication Reviews'
                            $router.push({ name: 'AdvocateMedReview' })
                          }
                        "
                        class="card-item"
                      >
                        Medication Reviews
                      </a-menu-item>
                      <a-menu-item
                        id="profilercmnd"
                        @click="
                          () => {
                            selectedTab = 'Profile Recommendations'
                            $router.push({ name: 'AdvocateProfileRec' })
                          }
                        "
                        class="card-item"
                      >
                        Profile Recommendations
                      </a-menu-item>
                      <a-menu-item
                        id="treatmentrcmnd"
                        @click="
                          () => {
                            selectedTab = 'Treatment Recommendations'
                            $router.push({ name: 'AdvocateTreatmentRec' })
                          }
                        "
                        class="card-item"
                      >
                        Treatment Recommendations
                      </a-menu-item>
                      <a-menu-item
                        id="profilercmnd"
                        @click="
                          () => {
                            selectedTab = 'Muted User'
                            $router.push({ name: 'AdvocateMutedUser' })
                          }
                        "
                        class="card-item"
                      >
                        Muted Users
                      </a-menu-item>
                    </a-menu>
                  </template>
                </a-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- mobile responsive view -->
      <div class="circle-card-advocate m-prof position-relative">
        <div class="circle-card-content-advocate text-center">
          <a-avatar :style="{ color: ' #ffffff !important', 'background-color': authUser.user.url ? authUser.user.url : '' ? '' : '#EF8585' }" :size="150" v-if="isFetchingprofileimage">
            <div>
              <div class="spinner-border spinner-class"></div>
            </div>
          </a-avatar>
          <a-avatar
            v-if="!isFetchingprofileimage"
            :style="{ color: ' #ffffff !important', 'background-color': authUser.user.url ? '' : '#EF8585' }"
            :size="150"
            :src="authUser.user.url"
            class="text-capitalize"
          >
            {{ authUser.user.display_name[0] }}
          </a-avatar>
          <button class="threedot-menu profile-avatar" @click="() => $refs.drawerRef.show()">
            <div class="dot-menu-cont">
              <div class="camera-icon-btn cp">
                <label class="camera-bttn cp d-flex d-flex justify-content-center align-items-center" aria-hidden="true" :style="{ background: getPrimaryColor() }">
                  <font-awesome-icon size="2x" :style="{ color: 'white !important', transform: 'scale(0.5)', height: '100%' }" :icon="['fas', 'camera']" />
                </label>
              </div>
            </div>
          </button>
          <button class="threedot-menu mob" :style="{ background: '#fff', border: 'none', display: 'flex', 'align-self': 'flex-end' }" @click="() => $refs.drawerShareRef.show()">
            <font-awesome-icon size="1x" :style="{ color: '#94A3B8' }" :icon="['fas', 'ellipsis-v']" />
          </button>
          <div class="doc-info" :style="{ 'margin-top': '26.5px !important' }">
            <p class="m-0 doc-name" v-if="authUser" :style="{ 'text-align': 'center' }">
              {{ authUser.user.display_name }}
            </p>
            <div class="tags">
              <div class="tag" :style="{ background: getPrimary50Color(), color: getPrimaryColor() }">
                <font-awesome-icon class="icon" :icon="['fal', 'bullhorn']" :style="{ color: getPrimaryColor() }" />
                Advocate
              </div>
              <div v-if="profileData.represent_organization" class="support-tag">Supporting {{ profileData.represent_organization }}</div>
            </div>
            <p :style="{ color: '#0F1734', 'margin-top': '17.5px !important' }" v-if="location && location[0].city" class="m-0 doc-loc d-flex align-items-center gap8">
              <font-awesome-icon size="1x" :style="{ color: '#0F1734' }" :icon="['fal', 'map-marker-alt']" />
              <span class="m-0 loc">
                {{ location[0].city }},
                {{ location[0].state }}
              </span>
            </p>

            <div class="join-detail" v-if="joinedDate">Member since: {{ formatDate(joinedDate) }}</div>
          </div>
          <div class="statistics">
            <div class="circle-mem">
              <span class="num">{{ circleMembers }}</span>
              <span class="num-text">Circle Members</span>
            </div>
            <div class="vertical-seperator"></div>
            <div class="circle-on">
              <span class="num">{{ circlesOn }}</span>
              <span class="num-text">Circle On</span>
            </div>
          </div>

          <div class="mt-5 w-100 mb-4" :style="{ 'z-index': '10' }">
            <div class="d-flex align-items-center mb-2">
              <h5 class="m-0 gray700 font20 fw700 flex1">Profile Completion</h5>
              <button
                class="d-flex align-items-center gap4 px-3 py-1 br8 fw700 font14"
                :style="{ background: getPrimary50Color(), color: getPrimaryColor(), border: 'none' }"
                @click="handleProfileEdit"
              >
                <font-awesome-icon :style="{ color: getPrimary300Color() }" :icon="['fas', 'pen']" class="font14" />
                Edit
              </button>
            </div>
            <a-progress :key="percentTotal" :percent="percentTotal" class="custom-progress" :strokeColor="getPrimaryColor()" :format="percent => `${percent}%`" />

            <p class="mt-4 mb-2 gray700 font16 fw700">Complete Profile</p>

            <SimpleLoader v-if="loadingProfC" :name="'profile completeness data'" class="mx-auto" />

            <div v-if="options.length && !loadingProfC">
              <div v-for="(item, index) in options" :key="index">
                <div :class="`${index % 2 === 0 ? 'bg-white' : 'bg-gray100'} d-flex align-items-center px-2 py-3`">
                  <font-awesome-icon class="success500 font20 ml-1" :icon="['fas', 'check-circle']" v-if="item.done" />
                  <p class="m-0 gray700 font16 ml-2">{{ `${item.display_name} - ${item.value}%` }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="m-prof-sub" :style="{ padding: '0px' }">
        <ul class="sub-nav text-center">
          <li
            :style="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/updates` ? { color: getPrimaryColor(), background: getPrimary50Color() } : { color: '#0F1734' }"
            id="updates"
            :class="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/updates` ? 'active-tabs' : 'tabs'"
            @click="$router.push({ name: 'AdvocateUpdates' })"
          >
            Updates
          </li>
          <li
            :style="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/about` ? { color: getPrimaryColor(), background: getPrimary50Color() } : { color: '#0F1734' }"
            id="about"
            :class="this.$route.path === `/${currentCircle.key_name}/profile/${authUser.user.role}/about` ? 'active-tabs' : 'tabs'"
            @click="$router.push({ name: 'AdvocateAbout' })"
          >
            About
          </li>
          <li
            :style="
              this.$route.path.includes('ViewAllCircle') ||
              this.$route.path.includes('allCircleMembers') ||
              this.$route.path.includes('AllCircleMembers') ||
              this.$route.path.includes('self') ||
              this.$route.path.includes('hospitals') ||
              this.$route.path.includes('clinics') ||
              this.$route.path.includes('nfp') ||
              this.$route.path.includes('hcp') ||
              this.$route.path.includes('providers')
                ? { color: getPrimaryColor(), background: getPrimary50Color() }
                : { color: '#0F1734' }
            "
            id="circles"
            :class="
              this.$route.path.includes('ViewAllCircle') ||
              this.$route.path.includes('allCircleMembers') ||
              this.$route.path.includes('AllCircleMembers') ||
              this.$route.path.includes('self') ||
              this.$route.path.includes('hospitals') ||
              this.$route.path.includes('clinics') ||
              this.$route.path.includes('nfp') ||
              this.$route.path.includes('hcp') ||
              this.$route.path.includes('providers')
                ? 'active-tabs'
                : 'tabs'
            "
            @click="handletab($event)"
          >
            Circles
          </li>
          <div
            @click="() => $refs.drawerMenuRef.show()"
            :style="
              this.$route.path.includes('qa') ||
              this.$route.path.includes('polls') ||
              this.$route.path.includes('saved') ||
              this.$route.path.includes('profilerev') ||
              this.$route.path.includes('medrev') ||
              this.$route.path.includes('profilercmnd') ||
              this.$route.path.includes('treatmentrcmnd')
                ? { color: getPrimaryColor(), background: getPrimary50Color() }
                : { color: '#0F1734' }
            "
            id="reviews"
            :class="
              this.$route.path.includes('qa') ||
              this.$route.path.includes('polls') ||
              this.$route.path.includes('saved') ||
              this.$route.path.includes('profilerev') ||
              this.$route.path.includes('medrev') ||
              this.$route.path.includes('profilercmnd') ||
              this.$route.path.includes('treatmentrcmnd')
                ? 'active-tabs'
                : 'tabs'
            "
          >
            <div
              :style="
                this.$route.path.includes('qa') ||
                this.$route.path.includes('polls') ||
                this.$route.path.includes('saved') ||
                this.$route.path.includes('profilerev') ||
                this.$route.path.includes('medrev') ||
                this.$route.path.includes('profilercmnd') ||
                this.$route.path.includes('treatmentrcmnd')
                  ? { color: getPrimaryColor() }
                  : ''
              "
              class="tabe"
            >
              <!-- {{ selectedTab }} -->
              {{ "Reviews & More" }}
              <font-awesome-icon size="1x" :icon="displayDots2M ? ['far', 'angle-up'] : ['far', 'angle-down']" class="mr-2" />
            </div>
          </div>
          <DrawerModal ref="drawerMenuRef">
            <div @click="() => $refs.drawerMenuRef.close()">
              <a-menu-item
                id="qa"
                @click="
                  () => {
                    selectedTab = 'Q&A'
                    $router.push({ path: `/${currentCircle.key_name}/profile/${authUser.user.role}/qa` })
                  }
                "
                class="drawer-item py-2"
              >
                Q&A
              </a-menu-item>
              <a-menu-item
                id="polls"
                @click="
                  () => {
                    selectedTab = 'Polls'
                    $router.push({ path: `/${currentCircle.key_name}/profile/${authUser.user.role}/polls` })
                  }
                "
                class="drawer-item py-2"
              >
                Polls
              </a-menu-item>
              <a-menu-item
                id="saved"
                @click="
                  () => {
                    selectedTab = 'Saved'
                    $router.push({ path: `/${currentCircle.key_name}/profile/${authUser.user.role}/saved` })
                  }
                "
                class="drawer-item py-2"
              >
                Saved
              </a-menu-item>
              <a-menu-item
                id="profilerev"
                @click="
                  () => {
                    selectedTab = 'Profile Reviews'
                    $router.push({ name: 'AdvocateProfileReview' })
                  }
                "
                class="drawer-item py-2"
              >
                Profile Reviews
              </a-menu-item>
              <a-menu-item
                id="medrev"
                @click="
                  () => {
                    selectedTab = 'Medication Reviews'
                    $router.push({ path: `/${currentCircle.key_name}/profile/${authUser.user.role}/medrev` })
                  }
                "
                class="drawer-item py-2"
              >
                Medication Reviews
              </a-menu-item>
              <a-menu-item
                id="profilercmnd"
                @click="
                  () => {
                    selectedTab = 'Profile Recommendations'
                    $router.push({ name: 'AdvocateProfileRec' })
                  }
                "
                class="drawer-item py-2"
              >
                Profile Recommendations
              </a-menu-item>
              <a-menu-item
                id="treatmentrcmnd"
                @click="
                  () => {
                    selectedTab = 'Treatment Recommendations'
                    $router.push({ path: `/${currentCircle.key_name}/profile/${authUser.user.role}/treatmentrcmnd` })
                  }
                "
                class="drawer-item py-2"
              >
                Treatment Recommendations
              </a-menu-item>
              <a-menu-item
                id="profilercmnd"
                @click="
                  () => {
                    selectedTab = 'Muted User'
                    $router.push({ path: `/${currentCircle.key_name}/profile/${authUser.user.role}/muteduser` })
                  }
                "
                class="drawer-item py-2"
              >
                Muted Users
              </a-menu-item>
            </div>
          </DrawerModal>
        </ul>
      </div>

      <div class="dovemed-wrapper m-prof-wrapper">
        <div class="row">
          <div class="col-md-4 col-lg-4 d-prof-progress">
            <!-- <div class="ad-container"></div> -->
          </div>
          <div class="col-md-8 col-lg-8 col-sm-12 col-xs-12 tp">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>

    <ProfileImageGalleryVue ref="profileImageGalleryModal" :handleLoader="handleLoader" />
    <BackgroundImageGallery :handleLoader="handleLoaderBg" ref="bgImageGalleryModal" />
    <AvatarModal ref="avatarModal" :handleProfilePic="handleProfilePic" />
    <ShareProfileModal ref="ShareProfileModal" />
    <DrawerModal ref="drawerBackgroundRef">
      <div @click="() => $refs.drawerBackgroundRef.close()">
        <p class="drawer-item" @click="() => $refs.bgImageGalleryModal.show(backgroundImages)">
          <font-awesome-icon size="1x" :icon="['fal', 'images']" class="mr-2" />
          Select image
        </p>
        <p class="drawer-item position-relative">
          <font-awesome-icon size="1x" :icon="['fal', 'arrow-from-bottom']" class="mr-2" />
          <input
            title=""
            class="camera-icon-inp position-absolute h-100 w-100"
            type="file"
            accept="image/png, image/jpeg, image/gif, image/svg+xml"
            ref="bg"
            @change="handleBackgroundPicUpload()"
            :style="{ left: '0', opacity: '0' }"
          />
          Upload image
        </p>
        <p class="divider mb-0"></p>
        <p :class="`drawer-item ${authUser.user.bg_img ? '' : 'disabled-remove-bg-btn'}`" @click="removebgImage()">
          <font-awesome-icon size="1x" :icon="['fal', 'trash']" class="mr-2" />
          Remove
        </p>
      </div>
    </DrawerModal>
    <DrawerModal ref="drawerRef">
      <div @click="() => $refs.drawerRef.close()">
        <p
          class="drawer-item"
          @click="
            () => {
              $refs.profileImageGalleryModal.show()
              isFetchingprofileimage = true
            }
          "
        >
          <font-awesome-icon size="1x" :icon="['fal', 'images']" class="mr-2" />
          Select avatar
        </p>
        <p class="drawer-item position-relative">
          <font-awesome-icon size="1x" :icon="['fal', 'arrow-from-bottom']" class="mr-2" />
          <input
            title=""
            class="camera-icon-inp position-absolute h-100 w-100"
            type="file"
            accept="image/png, image/jpeg, image/gif, image/svg+xml"
            ref="mfile"
            @change="handleMobileProfilePicUpload()"
            :style="{ left: '0', opacity: '0' }"
          />
          Upload image
        </p>
        <p class="divider mb-0"></p>
        <p :class="`drawer-item ${authUser.user.bg_img ? '' : 'disabled-remove-bg-btn'}`" @click="removeProfileImage()">
          <font-awesome-icon size="1x" :icon="['fal', 'trash']" class="mr-2" />
          Remove
        </p>
      </div>
    </DrawerModal>
    <DrawerModal ref="drawerShareRef">
      <div class="pb-2" @click="() => $refs.drawerShareRef.close()">
        <p class="drawer-item d-flex flex-row" :style="{ 'font-weight': '500', color: 'black' }" @click="() => $refs.ShareProfileModal.showModal()">
          <svg width="20" height="20" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
            <path
              d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
              fill="black"
            /></svg
          >Share Profile
        </p>
      </div>
    </DrawerModal>
  </div>
</template>

<script>
import AdvocateAbout from "./AdvocateAbout"
import moment from "moment"
import AdvocateCircles from "./AdvocateCircles"
import AdvocateFavorites from "./AdvocateFavorites"
import AdvocateUpdates from "./AdvocateUpdates"
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import s3Upload from "../../../utilities/imageUploader"
import { mapGetters } from "vuex"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faMapMarkerAlt } from "@fortawesome/pro-light-svg-icons"
library.add(faMapMarkerAlt)
import BackgroundImageGallery from "../../Modals/BackgroundImageGallery"
import ProfileImageGalleryVue from "../../Modals/ProfileImageGallery.vue"
import AvatarModal from "../../Modals/UserAvatarCreationModal.vue"
import ShareProfileModal from "../../Modals/ShareProfileModal.vue"
import SimpleLoader from "../../commons/SimpleLoader.vue"
import DrawerModal from "../../Modals/DrawerModal.vue"

const UserRepository = RepositoryFactory.get("user")
const AppRepository = RepositoryFactory.get("app")
export default {
  name: "AdvocateProfile",
  components: {
    AdvocateAbout,
    AdvocateCircles,
    AdvocateFavorites,
    AdvocateUpdates,
    BackgroundImageGallery,
    ProfileImageGalleryVue,
    AvatarModal,
    ShareProfileModal,
    SimpleLoader,
    DrawerModal,
  },
  data() {
    return {
      loadingProfC: false,
      location: null,
      apiUrl: "",
      apiDoc: "https://gist.githubusercontent.com/AbhijitKulkarni95/20a0421d6ad908fae1372c0efad9b4a4/raw/01c32d97571458bb0ca9ef730bb15227e114c69b/doctor_prof.json",
      apiPat: "https://gist.githubusercontent.com/AbhijitKulkarni95/20a0421d6ad908fae1372c0efad9b4a4/raw/01c32d97571458bb0ca9ef730bb15227e114c69b/patient_prof.json",
      cardKeys: null,
      editableData: null,
      toDeleteKeys: ["id", "created_at", "updated_at", "is_deleted", "user", "is_verified", "npi_number", "state_licence", "licence_number"],
      tabs: { updates: false, about: true, circles: false, qa: false, fav: false },
      activeTab: "about",
      user: null,
      displayDots: false,
      isFetchingprofileimage: false,
      isBackgroundImageLoading: false,
      displayprofileDots: false,
      displaypicDots: false,
      displayDots: false,
      displayDots2: false,
      displayDots2M: false,
      displayDots2W: false,
      selectedTab: "Reviews & More",
      circleMembers: 0,
      circlesOn: 0,
      profileData: {},
      joinedDate: null,
      percentTotal: 0,
      options: [],
      advocateOptions: [
        { key_name: "file_name", display_name: "Upload a profile image", value: "20", done: false },
        { key_name: "circle", display_name: "Add people to your circle", value: "20", done: false },
        { key_name: "display_name", display_name: "Display Name", value: "20", done: false },
        { key_name: "location", display_name: "Location", value: "10", done: false },
        { key_name: "dob", display_name: "Birthday", value: "10", done: false },
        { key_name: "gender", display_name: "Gender", value: "10", done: false },
        { key_name: "first_post", display_name: "Create your first post", value: "10", done: false },
        // { key_name: "represent_organization", display_name: "Represent Organization", value: "10", done: false },
      ],
    }
  },
  watch: {
    "authUser.user.url": function() {
      this.isFetchingprofileimage = false
    },
    selectedTab: {
      handler() {
        this.displayDots = false
        this.displayDots2 = false
        this.displayDots2M = false
        this.displayDots2W = false
      },
      immediate: true,
    },
    percent(v) {
      if (v) {
        this.Completeness()
        this.$store.commit("Posts/setPercent", false)
      }
    },
  },

  computed: {
    ...mapGetters({ percent: "Posts/percent", circleMembersCount: "User/cicleMembersCount" }),
  },
  created() {
    console.warn("AdvocateProfile.vue created")
    window.addEventListener("mouseup", () => {
      // if (this.displayDots) {
      //   setTimeout(() => {
      //     this.displayDots = false
      //   }, 100)
      // }
      if (this.displayprofileDots) {
        setTimeout(() => {
          this.displayprofileDots = false
        }, 100)
      }
      if (this.displaypicDots) {
        setTimeout(() => {
          this.displaypicDots = false
        }, 100)
      }
    })
    this.fetchData()
  },

  methods: {
    handleProfileEdit() {
      this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${this.authUser.user.role}/about` })
    },

    handleLoader(val = true) {
      this.isFetchingprofileimage = val
    },
    handleLoaderBg(val = true) {
      this.isBackgroundImageLoading = val
    },

    handletab(event) {
      this.displayDots = false
      this.displayDots2 = false
      this.displayDots2M = false
      this.displayDots2W = false
      switch (event.target.id) {
        case "updates":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${this.authUser.user.role}/updates` })
          break
        case "about":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${this.authUser.user.role}/about` })
          break
        case "circles":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${this.authUser.user.role}/circles/AllCircleMembers` })
          break
        case "qa":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${this.authUser.user.role}/qa` })
          break
        case "saved":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${this.authUser.user.role}/favorites` })
          break
        default:
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${this.authUser.user.role}/updates` })
          break
      }
    },

    /**
     * Handle Profile image Upload
     */

    async handleProfilePic(svgPic) {
      var svgElement = svgPic

      // Create your own image
      var img = document.createElement("img")

      // Serialize the svg to string
      var svgString = new XMLSerializer().serializeToString(svgElement)

      // Remove any characters outside the Latin1 range
      var decoded = unescape(encodeURIComponent(svgString))

      // Now we can use btoa to convert the svg to base64
      var base64 = btoa(decoded)

      var imgSource = `data:image/svg+xml;base64,${base64}`
      this.imageAva = imgSource
      this.handleProfilePicUpload(imgSource)
      // console.log("src", imgSource)
    },

    async handleProfilePicUpload(img) {
      this.isFetchingprofileimage = true
      const file = this.authUser.user.id + Date.now().toString() + ".svg"
      try {
        const urlPayload = { file_name: [file] }
        const urlData = await UserRepository.getPresignedUrl(urlPayload)
        // console.log("url data")
        function dataURLtoFile(dataurl, filename) {
          var arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n)
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
          }
          return new File([u8arr], filename, { type: mime })
        }
        let fileData = dataURLtoFile(img, file)
        // console.log(fileData)

        await s3Upload(urlData.data.data.url[0], fileData)

        const payload = { file_name: urlData.data.data.filename[0] }
        await UserRepository.updateProfilePic(payload, this.authUser.user, this.currentCircle.id)
        const updateData = await UserRepository.getSelfProfile(this.authUser.user, this.currentCircle.id)
        // console.log(updateData.data.data.user_info, "updatedata")
        const authUserData = updateData.data.data.user_info
        this.$store.commit("User/setAuthUserProfileImg", authUserData)
        // const authUserData = updateData.data.data[0];
        // this.$store.commit("User/setAuthUserProfile", authUserData);
        // window.location.reload();
      } catch (err) {}
    },
    getBackgroundImages() {
      AppRepository.getBackgroundImageGallery().then(res => {
        this.backgroundImages = res.data.data
      })
    },

    onLoadHandler: function() {
      this.isBackgroundImageLoading = false
    },
    /**
     * handle profile image upload
     */

    async handleWebProfilePicUpload() {
      console.log("handleWebProfilePicUpload()")
      this.isFetchingprofileimage = true
      const file = this.$refs.wfile.files[0]
      this.$refs.wfile.value = ""
      // console.log(file, "file")
      try {
        if (!file.type.includes("image")) {
          this.$notification.error({
            message: "Error",
            description: "Please select only image",
          })
          this.isFetchingprofileimage = false
          return
        }
        const urlPayload = { file_name: [file.name] }
        // console.log("afater urlpayload")
        const urlData = await UserRepository.getPresignedUrl(urlPayload)
        await s3Upload(urlData.data.data.url[0], file)
        const payload = { file_name: urlData.data.data.filename[0] }
        // console.log(payload, "payload")
        await UserRepository.updateProfilePic(payload, this.authUser.user, this.currentCircle.id)
        const updateData = await UserRepository.getSelfProfile(this.authUser.user, this.currentCircle.id)
        // console.log(updateData.data.data.user_info, "updatedata")
        const authUserData = updateData.data.data.user_info
        this.$store.commit("User/setAuthUserProfileImg", authUserData)
        this.$store.commit("Posts/setPercent", true)
        this.isFetchingprofileimage = false
        this.$notification.success({ message: "Success", description: "Image uploaded successfully" })
      } catch (err) {
        this.isFetchingprofileimage = false
      }
    },

    async handleMobileProfilePicUpload() {
      console.log("handleMobileProfilePicUpload()")
      this.isFetchingprofileimage = true
      const file = this.$refs.mfile.files[0]
      this.$refs.mfile.value = ""
      // console.log(file, "file")
      try {
        if (!file.type.includes("image")) {
          this.$notification.error({
            message: "Error",
            description: "Please select only image",
          })
          this.isFetchingprofileimage = false
          return
        }
        const urlPayload = { file_name: [file.name] }
        // console.log("afater urlpayload")
        const urlData = await UserRepository.getPresignedUrl(urlPayload)
        await s3Upload(urlData.data.data.url[0], file)
        const payload = { file_name: urlData.data.data.filename[0] }
        // console.log(payload, "payload")
        await UserRepository.updateProfilePic(payload, this.authUser.user, this.currentCircle.id)
        const updateData = await UserRepository.getSelfProfile(this.authUser.user, this.currentCircle.id)
        // console.log(updateData.data.data.user_info, "updatedata")
        const authUserData = updateData.data.data.user_info
        this.$store.commit("User/setAuthUserProfileImg", authUserData)
        this.isFetchingprofileimage = false
        this.$store.commit("Posts/setPercent", true)
      } catch (err) {
        this.isFetchingprofileimage = false
      }
    },

    /*
     * remove profile image
     */
    async removeProfileImage() {
      console.log("removeProfileImage()")
      this.isFetchingprofileimage = true
      const payload = { file_name: null }
      try {
        await UserRepository.updateProfilePic(payload, this.authUser.user, this.currentCircle.id)
        const updateData = await UserRepository.getSelfProfile(this.authUser.user, this.currentCircle.id)
        // console.log(updateData.data.data.user_info, "updatedata")
        const authUserData = updateData.data.data.user_info
        this.$store.commit("User/setAuthUserProfileImg", authUserData)
        this.isFetchingprofileimage = false
        this.$store.commit("Posts/setPercent", true)
        this.$notification.success({ message: "Success", description: "Image removed successfully" })
      } catch (err) {
        this.isFetchingprofileimage = false
      }
    },
    /**
     * Handle Background image Upload
     */
    // async handleBackgroundPicUpload() {
    //   const file = this.$refs.bg.files[0];

    //   try {
    //     const user = JSON.parse(localStorage.getItem("user"));
    //     const headers = {
    //       Authorization: `Bearer ${user.user.token}`
    //     };
    //     const urlData = await this.$http.post(
    //       `${process.env.BASE_API_URL}/backgroundimage/`,
    //       { image: "people", file_name: file.name },
    //       { headers }
    //     );

    //     // const url = `${process.env.BASE_API_URL}/user/?user_id=${user.user.id}`;
    //     const payload = {
    //       bg_img: urlData.data.data.id
    //     };
    //     // const updateData = await this.$http.put(url, payload, { headers });
    //     const updateData = await UserRepository.updateProfilePic(
    //       payload,
    //       this.authUser.user,
    //       this.currentCircle.id
    //     );
    //     const authUserData = updateData.data.data[0];
    //     console.log(authUserData);
    //     this.$store.commit("User/setAuthUserProfile", authUserData);
    //   } catch (err) {}
    // },

    async handleBackgroundPicUpload() {
      console.log("handleBackgroundPicUpload() is called")
      this.isBackgroundImageLoading = true

      const file = this.$refs.bg.files[0]
      this.$refs.bg.value = ""
      try {
        if (!file.type.includes("image")) {
          this.$notification.error({
            message: "Error",
            description: "Please select only image",
          })
          this.isBackgroundImageLoading = false
          return
        }
        const urlPayload = { file_name: [file.name] }
        const urlData = await UserRepository.getPresignedUrl(urlPayload)
        await s3Upload(urlData.data.data.url[0], file)
        const result = await this.$http.get(`${process.env.BASE_API_URL}/mastertable/?type=image&code=Background&key=User Upload`)

        const res = await this.$http.post(`${process.env.BASE_API_URL}/backgroundimage/`, { file_name: urlData.data.data.filename[0], image_type_id: result.data.data[0].id })
        const payload = { bg_img: res.data.data.id }
        const updateData = await UserRepository.updateProfilePic(payload, this.authUser.user, this.currentCircle.id)
        await this.fetchData()
        // const authUserData = updateData.data.data[0];
        // this.$store.commit("User/setAuthUserProfile", authUserData);
        this.isBackgroundImageLoading = false
      } catch (err) {
        this.isBackgroundImageLoading = false
        this.$notification.error({ message: "Failed", description: "Background Image not uploaded" })
        console.log(err)
      }
    },

    /**
     *  Remove bg image
     */

    async removebgImage() {
      if (!this.authUser.user.bg_img) {
        return
      }
      const payload = { bg_img: null }
      try {
        this.isBackgroundImageLoading = true
        const updateData = await UserRepository.updateProfilePic(payload, this.authUser.user, this.currentCircle.id)
        const authUserData = updateData.data.data[0]
        this.$store.commit("User/setAuthUserProfile", authUserData)
        this.isBackgroundImageLoading = false
      } catch (err) {
        this.isBackgroundImageLoading = false
        // console.log(err)
      }
    },

    /*
     * Fetch user profile data
     */
    async fetchData() {
      try {
        this.setAppLoaderStatus(true)
        this.user = JSON.parse(localStorage.getItem("user"))
        const res = await UserRepository.getSelfProfile(this.authUser.user, this.currentCircle.id)
        this.location = res.data.data.user_info.location
        this.joinedDate = res.data.data.user_info.joined_date || null
        this.$store.commit("User/setAuthUserProfileBgImg", res.data.data.user_info)
        this.circleMembers = res.data.data.no_of_members
        this.circlesOn = res.data.data.no_of_circle_on

        const res2 = await UserRepository.getAbout(this.authUser.user, this.currentCircle.id)
        this.profileData = res2.data.data ? res2.data.data[0] : {}

        await this.Completeness()
        this.setAppLoaderStatus(false)
      } catch (e) {
        this.setAppLoaderStatus(false)
      }
    },

    async Completeness() {
      try {
        this.loadingProfC = true
        this.options = []
        this.options = this.advocateOptions.map(data => {
          if (data.key_name === "circle") {
            return { ...data, done: !!this.authUser.user.no_of_members }
          } else if (data.key_name === "file_name") {
            return { ...data, done: !!this.authUser.user.url }
          } else if (["gender", "display_name", "location"].includes(data.key_name)) {
            return { ...data, done: true }
          } else if (data.key_name === "represent_organization") {
            return { ...data, done: !!(this.authUser.user.represent_organization || this.profileData.represent_organization) }
          } else if (data.key_name === "dob") {
            return { ...data, done: !!(this.authUser.user.dob || this.profileData.dob) }
          } else if (data.key_name === "first_post") {
            return { ...data, done: !!this.authUser.user.first_post }
          } else {
            return { ...data, done: false }
          }
        })
        const headers = { Authorization: `Bearer ${this.authUser.user.token}` }
        const advRes = await this.$http.get(`${process.env.BASE_API_URL}/advocateprofilecompletion/?circle_id=${this.currentCircle.id}`, { headers })
        this.percentTotal = advRes.data.message || 0
        this.loadingProfC = false
      } catch (e) {
        this.loadingProfC = false
      }
    },
  },

  filters: {
    humanize: function(value, capitalize = true) {
      if (!value) return ""
      return capitalize
        ? value
            .toLowerCase()
            .split("_")
            .map(e => e.toUpperCase())
            .join(" ")
        : value
            .toLowerCase()
            .split("_")
            .map(e => e.charAt(0).toUpperCase() + e.substring(1))
            .join(" ")
    },

    total: function(value, ...options) {
      if (!value) return ""
      return Array.isArray(value) ? `(${value.length})` : ""
    },
  },
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 427px) {
  .circle-card-advocate {
    padding: 16px !important ;
    margin: 0px;
  }
}

.support-tag {
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 8px;
  gap: 4px;
  height: 22px;
  background: #f1edff;
  border-radius: 4px;
  color: #906eff;
  text-transform: capitalize;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
}

.vertical-seperator {
  width: 1px;
  height: 36px;
  background: #cbd5e1;
}

.num {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #0f1734;
}

.num-text {
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #94a3b8;
}
.circle-on {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;

  width: 159.01px;
  height: 44px;
}

.circle-mem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;

  width: 159.01px;
  height: 44px;
}

.statistics {
  margin-bottom: 32px;
  margin-top: 48px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  padding: 24px 8px;
  width: 335px;
  height: 92px;
  background: #ffffff;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.seperator {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 0px;
  width: 335px;
  height: 16px;
  @media screen and (max-width: 700px) {
    display: none;
  }
}
.tp {
  margin-top: 60px;
  @media screen and (max-width: 900px) {
    margin-top: 2rem;
    // margin-top: 48px;
  }
}
.tag {
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  padding: 4px 8px;
  border-radius: 4px;
}
.tags {
  display: flex;
  width: 100%;
  // justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
}
.info-phy {
  p {
    margin-bottom: 0px;
  }

  .prof-details-title {
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #94a3b8;
  }

  .prof-details-value {
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    color: #0f1734;
  }
}

.padding-fix {
  margin-top: 10px;
  padding-top: 0px;
}
.advocate-profile-card-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  position: absolute;
  width: 383px;
  // height: 937px;
  background: #ffffff;
  box-shadow: 0px -8px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-top: -100px;
}

.profile-tabs {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  position: absolute;
  margin-left: 17px;
  z-index: 1;
}

.camera-bttn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  text-align: center;
  position: relative;
  z-index: 1;
  i {
    vertical-align: bottom;
    color: #fff !important;
  }
  input {
    opacity: 0;
    width: 100%;
  }
}

.active-tabs {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px !important;
  height: 48px;
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
}
.tabs {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px !important;
  height: 48px;
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  // color: #0F1734;
}

.camera-btn {
  width: 40px !important;
  height: 40px !important;
}

.profile-avatar {
  @media screen and (max-width: 900px) {
    left: -20px;
    top: 18px;
    position: relative;
    z-index: 10;
  }
  .menu-content {
    .card-item {
      padding: 10px 14px;
    }
  }
}

.divider {
  border: 1px solid #e2e8f0;
}

.banner {
  // min-height: 300px;
  // max-height: 400px;
  height: 400px;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}
.mob {
  @media screen and (max-width: 900px) {
    position: relative;
    // top: 140px;
    left: 301px;
    z-index: 10;
  }
}
.option-mob {
  @media screen and (max-width: 900px) {
    width: max-content;
  }
}

.profile-subnav {
  background: #fff;
}

.profile-image {
  min-width: 150px;
  height: 150px;
  border-radius: 50%;
  display: flex;
  align-self: center;
}

.doc-info {
  .doc-name {
    margin-top: 26.5px !important;
    font-weight: 700;
    font-size: 36px;
    line-height: 46px;
    color: #0f1734;
    display: flex;
    text-transform: capitalize;
  }

  .join-detail {
    margin-top: 17.5px;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #647490;
    display: flex;
  }

  .loc {
    font-weight: 700;
    font-size: 14px;
    line-height: 21px;
    color: #0f1734;
  }
  .doc-loc,
  .recommendations {
    font-size: 16px;
    word-break: break-all;
  }
}

ul.sub-nav {
  list-style-type: none;
  padding: 0;
  display: flex;
  align-items: center;

  li {
    display: inline-block;
    margin-right: 20px;
  }
}

.nav-sec {
  position: relative;
  width: 66%;
  text-align: right;
  margin-left: 365px;

  .sub-nav {
    position: absolute;
    width: 100%;
    bottom: 0;
  }
}

.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 20px;

  .title {
    font-size: 18px;
    font-weight: bold;
  }

  .sub-title {
    font-size: 16px;
    font-weight: 500;
  }
}
.profile-bg {
  @media screen and (max-width: 900px) {
    // position: relative;
    right: 52px !important;
    top: -200px !important;
    z-index: 15;
  }
  .camera-btn {
    position: absolute;
    bottom: -9%;
    right: 8vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.ad-container {
  background: #b6d28a;
  width: 100%;
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Advocate/AdvocateProfile.vue